import { render, staticRenderFns } from "./SendWaybillComponent.vue?vue&type=template&id=df6c9ffe&scoped=true"
import script from "./SendWaybillComponent.vue?vue&type=script&lang=js"
export * from "./SendWaybillComponent.vue?vue&type=script&lang=js"
import style0 from "./SendWaybillComponent.vue?vue&type=style&index=0&id=df6c9ffe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df6c9ffe",
  null
  
)

export default component.exports